import React, { useMemo } from 'react';
import { i18n } from '@lt/localization';

import type { IFilter } from '../types';
import MultichoiceFilterGroup from '../components/MultichoiceFilterGroup';

const SURFACE_TYPES = {
  SAND: i18n.t('filters.beach.surface.sand'),
  'SAND+PEBBLE': i18n.t('filters.beach.surface.sand_pebble'),
  PEBBLE: i18n.t('filters.beach.surface.pebble'),
  PLATFORM: i18n.t('filters.beach.surface.platform'),
};

const makeItems = (data) =>
  data.map((item) => ({ ...item, name: SURFACE_TYPES[item.id] }));

const FilterBeachSurface = ({
  data,
  isMobile = false,
  onChange,
  onClear,
  className = '',
  currencyCode,
}: IFilter): JSX.Element => {
  const items = useMemo(() => makeItems(data), [data]);
  return (
    <MultichoiceFilterGroup
      className={className}
      data={items}
      isMobile={isMobile}
      onChange={onChange}
      onClear={onClear}
      Filter={FilterBeachSurface}
      currencyCode={currencyCode}
    />
  );
};

export default Object.assign(FilterBeachSurface, {
  filterName: 'beach_surface',
  filterLabel: i18n.t('filters.beach.surface.title'),
  valuesLabel: (data) =>
    data
      .filter((item) => item.selected)
      .map((item) => SURFACE_TYPES[item.id])
      .reduce((prev: string, curr: string) => [prev, ', ', curr]),
});
